import React from 'react';
import { Leaf, Shield, Award, Users } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Values() {
  const {
    t
  } = useLanguage();
  const values = [{
    icon: Leaf,
    title: t.values.items.sustainability.title,
    description: t.values.items.sustainability.description
  }, {
    icon: Shield,
    title: t.values.items.compliance.title,
    description: t.values.items.compliance.description
  }, {
    icon: Award,
    title: t.values.items.quality.title,
    description: t.values.items.quality.description
  }, {
    icon: Users,
    title: t.values.items.community.title,
    description: t.values.items.community.description
  }];
  return <section className="w-full py-16 md:py-24 bg-gray-50" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-273">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-274">
            {t.values.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-275">
            {t.values.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-276">
            {t.values.subtitle}
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-277">
          {values.map((value, index) => <div key={index} className="group bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-emerald-200" data-id="element-278">
              <div className="w-14 h-14 bg-emerald-100 group-hover:bg-emerald-700 rounded-xl flex items-center justify-center mb-5 transition-colors duration-300" data-id="element-279">
                <value.icon className="w-7 h-7 text-emerald-700 group-hover:text-white transition-colors duration-300" data-id="element-280" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-281">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm" data-id="element-282">
                {value.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}